var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#1B2861"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09864 5.00044C6.0985 5.26565 5.98781 5.51993 5.79093 5.70737C5.59404 5.8948 5.32709 6.00002 5.04879 5.99989C4.7705 5.99976 4.50365 5.89428 4.30697 5.70666C4.11028 5.51904 3.99986 5.26465 4 4.99944C4.00014 4.73424 4.11083 4.47996 4.30771 4.29252C4.50459 4.10509 4.77155 3.99987 5.04984 4C5.32814 4.00013 5.59498 4.10561 5.79167 4.29323C5.98836 4.48085 6.09878 4.73524 6.09864 5.00044ZM6.13012 6.74035H4.03148V13H6.13012V6.74035ZM9.44596 6.74035H7.35782V13H9.42497V9.71518C9.42497 7.88528 11.9276 7.71529 11.9276 9.71518V13H14V9.03522C14 5.95039 10.2959 6.06539 9.42497 7.5803L9.44596 6.74035Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdin_icon.246dd699d27f0ee2630979cb64162241.svg";
export { ForwardRef as ReactComponent };